// Country names for the supported product languages, pinned from Node 22 ICU.
// Shared static data keeps server and browser labels identical during hydration.
export const COUNTRY_NAMES = {
    "en": {
        "AC": "Ascension Island",
        "AD": "Andorra",
        "AE": "United Arab Emirates",
        "AF": "Afghanistan",
        "AG": "Antigua & Barbuda",
        "AI": "Anguilla",
        "AL": "Albania",
        "AM": "Armenia",
        "AO": "Angola",
        "AR": "Argentina",
        "AS": "American Samoa",
        "AT": "Austria",
        "AU": "Australia",
        "AW": "Aruba",
        "AX": "Åland Islands",
        "AZ": "Azerbaijan",
        "BA": "Bosnia & Herzegovina",
        "BB": "Barbados",
        "BD": "Bangladesh",
        "BE": "Belgium",
        "BF": "Burkina Faso",
        "BG": "Bulgaria",
        "BH": "Bahrain",
        "BI": "Burundi",
        "BJ": "Benin",
        "BL": "St. Barthélemy",
        "BM": "Bermuda",
        "BN": "Brunei",
        "BO": "Bolivia",
        "BQ": "Caribbean Netherlands",
        "BR": "Brazil",
        "BS": "Bahamas",
        "BT": "Bhutan",
        "BW": "Botswana",
        "BY": "Belarus",
        "BZ": "Belize",
        "CA": "Canada",
        "CC": "Cocos (Keeling) Islands",
        "CD": "Congo - Kinshasa",
        "CF": "Central African Republic",
        "CG": "Congo - Brazzaville",
        "CH": "Switzerland",
        "CI": "Côte d’Ivoire",
        "CK": "Cook Islands",
        "CL": "Chile",
        "CM": "Cameroon",
        "CN": "China",
        "CO": "Colombia",
        "CR": "Costa Rica",
        "CU": "Cuba",
        "CV": "Cape Verde",
        "CW": "Curaçao",
        "CX": "Christmas Island",
        "CY": "Cyprus",
        "CZ": "Czechia",
        "DE": "Germany",
        "DJ": "Djibouti",
        "DK": "Denmark",
        "DM": "Dominica",
        "DO": "Dominican Republic",
        "DZ": "Algeria",
        "EC": "Ecuador",
        "EE": "Estonia",
        "EG": "Egypt",
        "EH": "Western Sahara",
        "ER": "Eritrea",
        "ES": "Spain",
        "ET": "Ethiopia",
        "FI": "Finland",
        "FJ": "Fiji",
        "FK": "Falkland Islands",
        "FM": "Micronesia",
        "FO": "Faroe Islands",
        "FR": "France",
        "GA": "Gabon",
        "GB": "United Kingdom",
        "GD": "Grenada",
        "GE": "Georgia",
        "GF": "French Guiana",
        "GG": "Guernsey",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "GL": "Greenland",
        "GM": "Gambia",
        "GN": "Guinea",
        "GP": "Guadeloupe",
        "GQ": "Equatorial Guinea",
        "GR": "Greece",
        "GT": "Guatemala",
        "GU": "Guam",
        "GW": "Guinea-Bissau",
        "GY": "Guyana",
        "HK": "Hong Kong SAR China",
        "HN": "Honduras",
        "HR": "Croatia",
        "HT": "Haiti",
        "HU": "Hungary",
        "ID": "Indonesia",
        "IE": "Ireland",
        "IL": "Israel",
        "IM": "Isle of Man",
        "IN": "India",
        "IO": "British Indian Ocean Territory",
        "IQ": "Iraq",
        "IR": "Iran",
        "IS": "Iceland",
        "IT": "Italy",
        "JE": "Jersey",
        "JM": "Jamaica",
        "JO": "Jordan",
        "JP": "Japan",
        "KE": "Kenya",
        "KG": "Kyrgyzstan",
        "KH": "Cambodia",
        "KI": "Kiribati",
        "KM": "Comoros",
        "KN": "St. Kitts & Nevis",
        "KP": "North Korea",
        "KR": "South Korea",
        "KW": "Kuwait",
        "KY": "Cayman Islands",
        "KZ": "Kazakhstan",
        "LA": "Laos",
        "LB": "Lebanon",
        "LC": "St. Lucia",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Liberia",
        "LS": "Lesotho",
        "LT": "Lithuania",
        "LU": "Luxembourg",
        "LV": "Latvia",
        "LY": "Libya",
        "MA": "Morocco",
        "MC": "Monaco",
        "MD": "Moldova",
        "ME": "Montenegro",
        "MF": "St. Martin",
        "MG": "Madagascar",
        "MH": "Marshall Islands",
        "MK": "North Macedonia",
        "ML": "Mali",
        "MM": "Myanmar (Burma)",
        "MN": "Mongolia",
        "MO": "Macao SAR China",
        "MP": "Northern Mariana Islands",
        "MQ": "Martinique",
        "MR": "Mauritania",
        "MS": "Montserrat",
        "MT": "Malta",
        "MU": "Mauritius",
        "MV": "Maldives",
        "MW": "Malawi",
        "MX": "Mexico",
        "MY": "Malaysia",
        "MZ": "Mozambique",
        "NA": "Namibia",
        "NC": "New Caledonia",
        "NE": "Niger",
        "NF": "Norfolk Island",
        "NG": "Nigeria",
        "NI": "Nicaragua",
        "NL": "Netherlands",
        "NO": "Norway",
        "NP": "Nepal",
        "NR": "Nauru",
        "NU": "Niue",
        "NZ": "New Zealand",
        "OM": "Oman",
        "PA": "Panama",
        "PE": "Peru",
        "PF": "French Polynesia",
        "PG": "Papua New Guinea",
        "PH": "Philippines",
        "PK": "Pakistan",
        "PL": "Poland",
        "PM": "St. Pierre & Miquelon",
        "PR": "Puerto Rico",
        "PS": "Palestinian Territories",
        "PT": "Portugal",
        "PW": "Palau",
        "PY": "Paraguay",
        "QA": "Qatar",
        "RE": "Réunion",
        "RO": "Romania",
        "RS": "Serbia",
        "RU": "Russia",
        "RW": "Rwanda",
        "SA": "Saudi Arabia",
        "SB": "Solomon Islands",
        "SC": "Seychelles",
        "SD": "Sudan",
        "SE": "Sweden",
        "SG": "Singapore",
        "SH": "St. Helena",
        "SI": "Slovenia",
        "SJ": "Svalbard & Jan Mayen",
        "SK": "Slovakia",
        "SL": "Sierra Leone",
        "SM": "San Marino",
        "SN": "Senegal",
        "SO": "Somalia",
        "SR": "Suriname",
        "SS": "South Sudan",
        "ST": "São Tomé & Príncipe",
        "SV": "El Salvador",
        "SX": "Sint Maarten",
        "SY": "Syria",
        "SZ": "Eswatini",
        "TA": "Tristan da Cunha",
        "TC": "Turks & Caicos Islands",
        "TD": "Chad",
        "TG": "Togo",
        "TH": "Thailand",
        "TJ": "Tajikistan",
        "TK": "Tokelau",
        "TL": "Timor-Leste",
        "TM": "Turkmenistan",
        "TN": "Tunisia",
        "TO": "Tonga",
        "TR": "Türkiye",
        "TT": "Trinidad & Tobago",
        "TV": "Tuvalu",
        "TW": "Taiwan",
        "TZ": "Tanzania",
        "UA": "Ukraine",
        "UG": "Uganda",
        "US": "United States",
        "UY": "Uruguay",
        "UZ": "Uzbekistan",
        "VA": "Vatican City",
        "VC": "St. Vincent & Grenadines",
        "VE": "Venezuela",
        "VG": "British Virgin Islands",
        "VI": "U.S. Virgin Islands",
        "VN": "Vietnam",
        "VU": "Vanuatu",
        "WF": "Wallis & Futuna",
        "WS": "Samoa",
        "XK": "Kosovo",
        "YE": "Yemen",
        "YT": "Mayotte",
        "ZA": "South Africa",
        "ZM": "Zambia",
        "ZW": "Zimbabwe"
    },
    "fr": {
        "AC": "Île de l’Ascension",
        "AD": "Andorre",
        "AE": "Émirats arabes unis",
        "AF": "Afghanistan",
        "AG": "Antigua-et-Barbuda",
        "AI": "Anguilla",
        "AL": "Albanie",
        "AM": "Arménie",
        "AO": "Angola",
        "AR": "Argentine",
        "AS": "Samoa américaines",
        "AT": "Autriche",
        "AU": "Australie",
        "AW": "Aruba",
        "AX": "Îles Åland",
        "AZ": "Azerbaïdjan",
        "BA": "Bosnie-Herzégovine",
        "BB": "Barbade",
        "BD": "Bangladesh",
        "BE": "Belgique",
        "BF": "Burkina Faso",
        "BG": "Bulgarie",
        "BH": "Bahreïn",
        "BI": "Burundi",
        "BJ": "Bénin",
        "BL": "Saint-Barthélemy",
        "BM": "Bermudes",
        "BN": "Brunei",
        "BO": "Bolivie",
        "BQ": "Pays-Bas caribéens",
        "BR": "Brésil",
        "BS": "Bahamas",
        "BT": "Bhoutan",
        "BW": "Botswana",
        "BY": "Biélorussie",
        "BZ": "Belize",
        "CA": "Canada",
        "CC": "Îles Cocos",
        "CD": "Congo-Kinshasa",
        "CF": "République centrafricaine",
        "CG": "Congo-Brazzaville",
        "CH": "Suisse",
        "CI": "Côte d’Ivoire",
        "CK": "Îles Cook",
        "CL": "Chili",
        "CM": "Cameroun",
        "CN": "Chine",
        "CO": "Colombie",
        "CR": "Costa Rica",
        "CU": "Cuba",
        "CV": "Cap-Vert",
        "CW": "Curaçao",
        "CX": "Île Christmas",
        "CY": "Chypre",
        "CZ": "Tchéquie",
        "DE": "Allemagne",
        "DJ": "Djibouti",
        "DK": "Danemark",
        "DM": "Dominique",
        "DO": "République dominicaine",
        "DZ": "Algérie",
        "EC": "Équateur",
        "EE": "Estonie",
        "EG": "Égypte",
        "EH": "Sahara occidental",
        "ER": "Érythrée",
        "ES": "Espagne",
        "ET": "Éthiopie",
        "FI": "Finlande",
        "FJ": "Fidji",
        "FK": "Îles Malouines",
        "FM": "Micronésie",
        "FO": "Îles Féroé",
        "FR": "France",
        "GA": "Gabon",
        "GB": "Royaume-Uni",
        "GD": "Grenade",
        "GE": "Géorgie",
        "GF": "Guyane française",
        "GG": "Guernesey",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "GL": "Groenland",
        "GM": "Gambie",
        "GN": "Guinée",
        "GP": "Guadeloupe",
        "GQ": "Guinée équatoriale",
        "GR": "Grèce",
        "GT": "Guatemala",
        "GU": "Guam",
        "GW": "Guinée-Bissau",
        "GY": "Guyana",
        "HK": "R.A.S. chinoise de Hong Kong",
        "HN": "Honduras",
        "HR": "Croatie",
        "HT": "Haïti",
        "HU": "Hongrie",
        "ID": "Indonésie",
        "IE": "Irlande",
        "IL": "Israël",
        "IM": "Île de Man",
        "IN": "Inde",
        "IO": "Territoire britannique de l’océan Indien",
        "IQ": "Irak",
        "IR": "Iran",
        "IS": "Islande",
        "IT": "Italie",
        "JE": "Jersey",
        "JM": "Jamaïque",
        "JO": "Jordanie",
        "JP": "Japon",
        "KE": "Kenya",
        "KG": "Kirghizstan",
        "KH": "Cambodge",
        "KI": "Kiribati",
        "KM": "Comores",
        "KN": "Saint-Christophe-et-Niévès",
        "KP": "Corée du Nord",
        "KR": "Corée du Sud",
        "KW": "Koweït",
        "KY": "Îles Caïmans",
        "KZ": "Kazakhstan",
        "LA": "Laos",
        "LB": "Liban",
        "LC": "Sainte-Lucie",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Liberia",
        "LS": "Lesotho",
        "LT": "Lituanie",
        "LU": "Luxembourg",
        "LV": "Lettonie",
        "LY": "Libye",
        "MA": "Maroc",
        "MC": "Monaco",
        "MD": "Moldavie",
        "ME": "Monténégro",
        "MF": "Saint-Martin",
        "MG": "Madagascar",
        "MH": "Îles Marshall",
        "MK": "Macédoine du Nord",
        "ML": "Mali",
        "MM": "Myanmar (Birmanie)",
        "MN": "Mongolie",
        "MO": "R.A.S. chinoise de Macao",
        "MP": "Îles Mariannes du Nord",
        "MQ": "Martinique",
        "MR": "Mauritanie",
        "MS": "Montserrat",
        "MT": "Malte",
        "MU": "Maurice",
        "MV": "Maldives",
        "MW": "Malawi",
        "MX": "Mexique",
        "MY": "Malaisie",
        "MZ": "Mozambique",
        "NA": "Namibie",
        "NC": "Nouvelle-Calédonie",
        "NE": "Niger",
        "NF": "Île Norfolk",
        "NG": "Nigeria",
        "NI": "Nicaragua",
        "NL": "Pays-Bas",
        "NO": "Norvège",
        "NP": "Népal",
        "NR": "Nauru",
        "NU": "Niue",
        "NZ": "Nouvelle-Zélande",
        "OM": "Oman",
        "PA": "Panama",
        "PE": "Pérou",
        "PF": "Polynésie française",
        "PG": "Papouasie-Nouvelle-Guinée",
        "PH": "Philippines",
        "PK": "Pakistan",
        "PL": "Pologne",
        "PM": "Saint-Pierre-et-Miquelon",
        "PR": "Porto Rico",
        "PS": "Territoires palestiniens",
        "PT": "Portugal",
        "PW": "Palaos",
        "PY": "Paraguay",
        "QA": "Qatar",
        "RE": "La Réunion",
        "RO": "Roumanie",
        "RS": "Serbie",
        "RU": "Russie",
        "RW": "Rwanda",
        "SA": "Arabie saoudite",
        "SB": "Îles Salomon",
        "SC": "Seychelles",
        "SD": "Soudan",
        "SE": "Suède",
        "SG": "Singapour",
        "SH": "Sainte-Hélène",
        "SI": "Slovénie",
        "SJ": "Svalbard et Jan Mayen",
        "SK": "Slovaquie",
        "SL": "Sierra Leone",
        "SM": "Saint-Marin",
        "SN": "Sénégal",
        "SO": "Somalie",
        "SR": "Suriname",
        "SS": "Soudan du Sud",
        "ST": "Sao Tomé-et-Principe",
        "SV": "Salvador",
        "SX": "Saint-Martin (partie néerlandaise)",
        "SY": "Syrie",
        "SZ": "Eswatini",
        "TA": "Tristan da Cunha",
        "TC": "Îles Turques-et-Caïques",
        "TD": "Tchad",
        "TG": "Togo",
        "TH": "Thaïlande",
        "TJ": "Tadjikistan",
        "TK": "Tokelau",
        "TL": "Timor oriental",
        "TM": "Turkménistan",
        "TN": "Tunisie",
        "TO": "Tonga",
        "TR": "Turquie",
        "TT": "Trinité-et-Tobago",
        "TV": "Tuvalu",
        "TW": "Taïwan",
        "TZ": "Tanzanie",
        "UA": "Ukraine",
        "UG": "Ouganda",
        "US": "États-Unis",
        "UY": "Uruguay",
        "UZ": "Ouzbékistan",
        "VA": "État de la Cité du Vatican",
        "VC": "Saint-Vincent-et-les Grenadines",
        "VE": "Venezuela",
        "VG": "Îles Vierges britanniques",
        "VI": "Îles Vierges des États-Unis",
        "VN": "Viêt Nam",
        "VU": "Vanuatu",
        "WF": "Wallis-et-Futuna",
        "WS": "Samoa",
        "XK": "Kosovo",
        "YE": "Yémen",
        "YT": "Mayotte",
        "ZA": "Afrique du Sud",
        "ZM": "Zambie",
        "ZW": "Zimbabwe"
    },
    "it": {
        "AC": "Isola Ascensione",
        "AD": "Andorra",
        "AE": "Emirati Arabi Uniti",
        "AF": "Afghanistan",
        "AG": "Antigua e Barbuda",
        "AI": "Anguilla",
        "AL": "Albania",
        "AM": "Armenia",
        "AO": "Angola",
        "AR": "Argentina",
        "AS": "Samoa Americane",
        "AT": "Austria",
        "AU": "Australia",
        "AW": "Aruba",
        "AX": "Isole Åland",
        "AZ": "Azerbaigian",
        "BA": "Bosnia ed Erzegovina",
        "BB": "Barbados",
        "BD": "Bangladesh",
        "BE": "Belgio",
        "BF": "Burkina Faso",
        "BG": "Bulgaria",
        "BH": "Bahrein",
        "BI": "Burundi",
        "BJ": "Benin",
        "BL": "Saint-Barthélemy",
        "BM": "Bermuda",
        "BN": "Brunei",
        "BO": "Bolivia",
        "BQ": "Caraibi Olandesi",
        "BR": "Brasile",
        "BS": "Bahamas",
        "BT": "Bhutan",
        "BW": "Botswana",
        "BY": "Bielorussia",
        "BZ": "Belize",
        "CA": "Canada",
        "CC": "Isole Cocos (Keeling)",
        "CD": "Congo - Kinshasa",
        "CF": "Repubblica Centrafricana",
        "CG": "Congo-Brazzaville",
        "CH": "Svizzera",
        "CI": "Costa d’Avorio",
        "CK": "Isole Cook",
        "CL": "Cile",
        "CM": "Camerun",
        "CN": "Cina",
        "CO": "Colombia",
        "CR": "Costa Rica",
        "CU": "Cuba",
        "CV": "Capo Verde",
        "CW": "Curaçao",
        "CX": "Isola Christmas",
        "CY": "Cipro",
        "CZ": "Cechia",
        "DE": "Germania",
        "DJ": "Gibuti",
        "DK": "Danimarca",
        "DM": "Dominica",
        "DO": "Repubblica Dominicana",
        "DZ": "Algeria",
        "EC": "Ecuador",
        "EE": "Estonia",
        "EG": "Egitto",
        "EH": "Sahara Occidentale",
        "ER": "Eritrea",
        "ES": "Spagna",
        "ET": "Etiopia",
        "FI": "Finlandia",
        "FJ": "Figi",
        "FK": "Isole Falkland",
        "FM": "Micronesia",
        "FO": "Isole Fær Øer",
        "FR": "Francia",
        "GA": "Gabon",
        "GB": "Regno Unito",
        "GD": "Grenada",
        "GE": "Georgia",
        "GF": "Guyana Francese",
        "GG": "Guernsey",
        "GH": "Ghana",
        "GI": "Gibilterra",
        "GL": "Groenlandia",
        "GM": "Gambia",
        "GN": "Guinea",
        "GP": "Guadalupa",
        "GQ": "Guinea Equatoriale",
        "GR": "Grecia",
        "GT": "Guatemala",
        "GU": "Guam",
        "GW": "Guinea-Bissau",
        "GY": "Guyana",
        "HK": "RAS di Hong Kong",
        "HN": "Honduras",
        "HR": "Croazia",
        "HT": "Haiti",
        "HU": "Ungheria",
        "ID": "Indonesia",
        "IE": "Irlanda",
        "IL": "Israele",
        "IM": "Isola di Man",
        "IN": "India",
        "IO": "Territorio Britannico dell’Oceano Indiano",
        "IQ": "Iraq",
        "IR": "Iran",
        "IS": "Islanda",
        "IT": "Italia",
        "JE": "Jersey",
        "JM": "Giamaica",
        "JO": "Giordania",
        "JP": "Giappone",
        "KE": "Kenya",
        "KG": "Kirghizistan",
        "KH": "Cambogia",
        "KI": "Kiribati",
        "KM": "Comore",
        "KN": "Saint Kitts e Nevis",
        "KP": "Corea del Nord",
        "KR": "Corea del Sud",
        "KW": "Kuwait",
        "KY": "Isole Cayman",
        "KZ": "Kazakistan",
        "LA": "Laos",
        "LB": "Libano",
        "LC": "Saint Lucia",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Liberia",
        "LS": "Lesotho",
        "LT": "Lituania",
        "LU": "Lussemburgo",
        "LV": "Lettonia",
        "LY": "Libia",
        "MA": "Marocco",
        "MC": "Monaco",
        "MD": "Moldavia",
        "ME": "Montenegro",
        "MF": "Saint Martin",
        "MG": "Madagascar",
        "MH": "Isole Marshall",
        "MK": "Macedonia del Nord",
        "ML": "Mali",
        "MM": "Myanmar (Birmania)",
        "MN": "Mongolia",
        "MO": "RAS di Macao",
        "MP": "Isole Marianne Settentrionali",
        "MQ": "Martinica",
        "MR": "Mauritania",
        "MS": "Montserrat",
        "MT": "Malta",
        "MU": "Mauritius",
        "MV": "Maldive",
        "MW": "Malawi",
        "MX": "Messico",
        "MY": "Malaysia",
        "MZ": "Mozambico",
        "NA": "Namibia",
        "NC": "Nuova Caledonia",
        "NE": "Niger",
        "NF": "Isola Norfolk",
        "NG": "Nigeria",
        "NI": "Nicaragua",
        "NL": "Paesi Bassi",
        "NO": "Norvegia",
        "NP": "Nepal",
        "NR": "Nauru",
        "NU": "Niue",
        "NZ": "Nuova Zelanda",
        "OM": "Oman",
        "PA": "Panama",
        "PE": "Perù",
        "PF": "Polinesia Francese",
        "PG": "Papua Nuova Guinea",
        "PH": "Filippine",
        "PK": "Pakistan",
        "PL": "Polonia",
        "PM": "Saint-Pierre e Miquelon",
        "PR": "Portorico",
        "PS": "Territori Palestinesi",
        "PT": "Portogallo",
        "PW": "Palau",
        "PY": "Paraguay",
        "QA": "Qatar",
        "RE": "Riunione",
        "RO": "Romania",
        "RS": "Serbia",
        "RU": "Russia",
        "RW": "Ruanda",
        "SA": "Arabia Saudita",
        "SB": "Isole Salomone",
        "SC": "Seychelles",
        "SD": "Sudan",
        "SE": "Svezia",
        "SG": "Singapore",
        "SH": "Sant’Elena",
        "SI": "Slovenia",
        "SJ": "Svalbard e Jan Mayen",
        "SK": "Slovacchia",
        "SL": "Sierra Leone",
        "SM": "San Marino",
        "SN": "Senegal",
        "SO": "Somalia",
        "SR": "Suriname",
        "SS": "Sud Sudan",
        "ST": "São Tomé e Príncipe",
        "SV": "El Salvador",
        "SX": "Sint Maarten",
        "SY": "Siria",
        "SZ": "Eswatini",
        "TA": "Tristan da Cunha",
        "TC": "Isole Turks e Caicos",
        "TD": "Ciad",
        "TG": "Togo",
        "TH": "Thailandia",
        "TJ": "Tagikistan",
        "TK": "Tokelau",
        "TL": "Timor Est",
        "TM": "Turkmenistan",
        "TN": "Tunisia",
        "TO": "Tonga",
        "TR": "Turchia",
        "TT": "Trinidad e Tobago",
        "TV": "Tuvalu",
        "TW": "Taiwan",
        "TZ": "Tanzania",
        "UA": "Ucraina",
        "UG": "Uganda",
        "US": "Stati Uniti",
        "UY": "Uruguay",
        "UZ": "Uzbekistan",
        "VA": "Città del Vaticano",
        "VC": "Saint Vincent e Grenadine",
        "VE": "Venezuela",
        "VG": "Isole Vergini Britanniche",
        "VI": "Isole Vergini Americane",
        "VN": "Vietnam",
        "VU": "Vanuatu",
        "WF": "Wallis e Futuna",
        "WS": "Samoa",
        "XK": "Kosovo",
        "YE": "Yemen",
        "YT": "Mayotte",
        "ZA": "Sudafrica",
        "ZM": "Zambia",
        "ZW": "Zimbabwe"
    }
};
